export const Z_INDEX = {
  calendarModal: 10005,
  calendarSidebarDatePicker: 10006,
  calendarConfirmModal: 10007,
  calendarDatePickerPortal: 10010
};

export const Z_INDEX_CLASS = {
  calendarModal: '!tw-z-[10005]',
  calendarSidebarDatePicker: 'tw-z-[10006]',
  calendarConfirmModal: '!tw-z-[10007]'
};
